export const FIREBASE_URL = import.meta.env.VITE_FIREBASE_URL;
export const API_URL = import.meta.env.VITE_API_URL;
export const NEW_API_URL = import.meta.env.VITE_NEW_API_URL;
